import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '~/constants/keys'
import { getConnectedAccounts } from '~/generated/client'
import { getDuration } from '~/utils/duration'
import { useRouterParsed } from '../utils/useRouterParse'
import { useGetAllToolkits } from './tools'

export const useGetAllConnections = () => {
  const {
    page = '1',
    authConfigId,
    status = undefined,
    entityId,
    query,
  } = useRouterParsed()
  const { getLogo } = useGetAllToolkits({ page: 1 })
  const normalizedStatus = status?.toLowerCase() === 'all' ? undefined : status

  const {
    data: connections,
    isLoading,
    isError,
    isSuccess,
    refetch,
  } = useQuery({
    queryKey: QUERY_KEYS.getConnectionsQueryKey(query),
    queryFn: () =>
      getConnectedAccounts({
        authConfigIds: authConfigId ? [authConfigId] : undefined,
        statuses: normalizedStatus ? [normalizedStatus] : undefined,
        limit: 20,
        cursor: page !== '1' ? Number(page) : undefined,
        userIds: entityId ? [entityId] : undefined,
        orderBy: 'created_at',
      }),
    staleTime: getDuration({ minutes: 5 }),
    retry: false,
  })

  const finalConnections = useMemo(() => {
    const items = connections?.items?.map((connection) => ({
      ...connection,
      toolkit: {
        ...connection.toolkit,
        logo: getLogo(connection.toolkit.slug),
      },
      authConfig: {
        id: connection.auth_config.id,
        auth_scheme: connection.auth_config.auth_scheme,
        is_composio_managed: connection.auth_config.is_composio_managed,
        is_disabled: false,
      },
      is_disabled: false,
    }))

    return {
      ...connections,
      items,
    }
  }, [connections, getLogo])

  return {
    connections: finalConnections,
    isLoading,
    isError,
    isSuccess,
    refetch,
  }
}
